const API_URL = '/api/cvs';

export const getCvs = async (token) => {
    const response = await fetch(API_URL, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || err.error || 'Failed to fetch CVs');
    }

    return response.json();
};

export const uploadCv = async (file, token) => {
    const formData = new FormData();
    formData.append('cv', file);

    const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        body: formData
    });

    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || err.error || 'Failed to upload CV');
    }

    return response.json();
};

export const deleteCv = async (id, token) => {
    const response = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || err.error || 'Failed to delete CV');
    }

    return response.json();
};

export const setDefaultCv = async (id, token) => {
    const response = await fetch(`${API_URL}/${id}/default`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || err.error || 'Failed to set default CV');
    }

    return response.json();
};
